<template>
    <div class="centrado">
        <div>
        <h1>Error...</h1>

        </div>
    
        <div>
            <CButton @click="back" color="primary">Volver</CButton>
        </div>
    </div>
</template>

<script>
export default{
    name: "Error",
    data(){
        return {

        }
    },
    methods: {
        back() {
            this.$router.push("/login");
        }
    }
}
</script>

<style>
.centrado{
    height: 100vh;
    
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
}
</style>